var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { SvgIcon as Svg } from 'ha/ui/SvgIcon';

const SvgHousingAnywhereIcon = props => /*#__PURE__*/React.createElement(Svg, _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 45 45"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M41.7 44.5H3.3c-1.7 0-3.1-1.4-3.1-3.1 0-1.7 1.4-3.1 3.1-3.1h35.3V21.1L22.3 7.6 6.4 21.1v7.4c0 1.7-1.4 3.1-3.1 3.1-1.7 0-3.1-1.4-3.1-3.1v-8.8c0-.9.4-1.8 1.1-2.3l19-16.1c1.1-1 2.8-1 3.9 0l19.4 16.1c.7.6 1.1 1.5 1.1 2.4v21.8c0 1.5-1.3 2.9-3 2.9z"
})));

export default SvgHousingAnywhereIcon;